if(!customElements.get('pickup-availability')){
    class PickupAvailability extends HTMLElement {
        constructor(){
            super();
            
            this.init();
        }

        init(){
            this.template = this.querySelector('template').content.cloneNode(true);
            this.rootUrl = this.dataset.rootUrl;
            
            if(!this.rootUrl.endsWith('/')){
                this.rootUrl = this.rootUrl + "/";
            }

            this.variantId = this.dataset.variantId;
            this.btnStyle = this.dataset.btnStyle;

            this.fetchAvailability();
        }

        updateVariantId(){
            this.variantId = this.dataset.variantId;
            this.fetchAvailability();
        }

        fetchAvailability(){
            const variantSectionUrl = `${this.rootUrl}variants/${this.variantId}/?section_id=pickup-availability`;
            
            fetch(variantSectionUrl)
            .then(res => res.text())
            .then(text => {
                const sectionInnerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('.shopify-section');

                this.renderPreview(sectionInnerHTML);
            })
            .catch(e => {
                this.renderError();
            })
        }

        refreshList(){
            this.fetchAvailability(this.dataset.variantId);
        }

        renderError(){
            this.innerHTML = '';
        }

        renderPreview(sectionInnerHTML){
           this.sidebar = document.querySelector('sidebar-pickup-availability');
            if(this.sidebar) this.sidebar.remove();

            if(!sectionInnerHTML.querySelector('pickup-availability-preview')){
                this.innerHTML = '';
                this.setAttribute('data-hidden', 'true');
                return;
            }

            if(this.btnStyle == 'secondary'){
                sectionInnerHTML.querySelector('.custom-btn').classList.add('custom-btn--secondary');
            }

            this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
            this.setAttribute('data-hidden', 'false');

            document.body.appendChild(sectionInnerHTML.querySelector('sidebar-pickup-availability'));

            this.btn = this.querySelector('button');
            if(this.btn){
                this.btn.addEventListener('click', e => {
                    e.preventDefault();
                    document.querySelector('sidebar-pickup-availability').setAttribute('data-hidden', 'false');
                    document.querySelector('html').style.overflow = 'hidden';
                })
            }
        }
    }

    customElements.define('pickup-availability', PickupAvailability);
}

if(!customElements.get('sidebar-pickup-availability')){
    class SidebarPickupAvailability extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.btnClose = this.querySelector('.btn-close');

            this.btnClose.addEventListener('click', this.closeSidebar.bind(this));
            document.addEventListener('keyup', e => {
                if(e.code.toUpperCase() == 'ESCAPE') this.closeSidebar();
            })

            this.addEventListener('click', this.checkIfBodyClicked.bind(this));

            this.adjustBackgroundHeight();
        }

        checkIfBodyClicked(e){
            const target = e.target;
            if (target == this){
                this.closeSidebar();
            }
        }

        closeSidebar(){
            this.setAttribute('data-hidden', 'true');
            document.querySelector('html').style.overflow = 'initial';
        }

        adjustBackgroundHeight(){
            var contentHeight = this.querySelector('.sidebar-pickup-availability-content-wrapper').scrollHeight;
            this.querySelector('.sidebar-pickup-availability-background').style.height = `calc(${contentHeight}px + 2rem)`;
        }
    }

    customElements.define('sidebar-pickup-availability', SidebarPickupAvailability);
}